import { TreeNode } from 'primeng/api';
import { CategoryModel } from '@cpak/adp-cpak-products-service-models';
import { FlatNode } from '../../interfaces/flat-node';

export function getAllNodes<T>(nodes: TreeNode<T>[]): TreeNode<T>[] {
  return nodes.reduce((acc, node) => {
    acc.push(node);
    if (node.children) {
      acc.push(...getAllNodes(node.children));
    }
    return acc;
  }, [] as TreeNode[]);
}

export function convertCategoriesToFlatNodes(categories: CategoryModel[]): FlatNode<CategoryModel>[] {
  return categories.map(category => {
    return {
      id: category.id,
      parentId: category.parentId,
      data: category,
    };
  });
}

export function convertToTree<T>(flatNodes: FlatNode<T>[]): TreeNode<T>[] {
  const map = new Map<string, TreeNode<T>>();

  // First pass: create all nodes
  flatNodes.forEach(flatNode => {
    const { id, data } = flatNode;
    const node: TreeNode<T> = { label: id, type: 'node', data, children: [] };

    map.set(id, node);
  });

  // Second pass: link up parent and child nodes
  flatNodes.forEach(flatNode => {
    const { id, parentId } = flatNode;
    const node = map.get(id);

    const parentNode = parentId && map.get(parentId);
    if (parentNode && node) {
      node.parent = parentNode;
      parentNode.children?.push(node);
    }
  });

  // Return root nodes (nodes with no parent)
  return Array.from(map.values()).filter(node => !node.parent);
}

export function convertCategoriesToTree(categories: CategoryModel[]): TreeNode<CategoryModel>[] {
  const sortedCategories = categories.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  const flatNodes = convertCategoriesToFlatNodes(sortedCategories);
  return convertToTree(flatNodes);
}

export function getCategoryIdsFromTree(nodes: TreeNode<CategoryModel>[]): string[] {
  return nodes.map(node => node.data?.id).filter((id): id is string => !!id);
}
